import * as dateTimeFunctions from './src/lib/date-time-functions';
import * as fileSystemFunctions from './src/lib/file-system-functions';
import * as mathFunctions from './src/lib/math-functions';
import * as parsingFunctions from './src/lib/parsing-functions';
import * as streamFunctions from './src/lib/stream-functions';

export const DateTimeFunctions = new dateTimeFunctions.DateTimeFunctions();
export const FileSystemFunctions = new fileSystemFunctions.FileSystemFunctions();
export const MathFunctions = new mathFunctions.MathFunctions();
export const ParsingFunctions = new parsingFunctions.ParsingFunctions();
export const StreamFunctions = new streamFunctions.StreamFunctions();
